<template>
  <d-row>
    <d-col lg="4">
      <d-card class="card-small mb-4 pt-3">

        <!-- Card Header -->
        <d-card-header class="border-bottom text-center">
          <!-- User Avatar -->
          <div class="mb-3 mx-auto overflow-hidden">
            <upload-image :model.sync="model.settings"></upload-image>
          </div>
          <!-- User Name -->
          <h4 class="mb-0">{{ roleName }}</h4>

          <!-- User Job Title -->
          <span class="text-muted d-block mb-2">{{ model.settings.type.name }}</span>

        </d-card-header>

      </d-card>
    </d-col>
    <d-col lg="8">
      <d-card class="card-small mb-4">

        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">{{ title }}</h6>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <d-form @submit.prevent="save" :validated="hasErrors">
                  <d-form-row>

                    <!-- Nome -->
                    <d-col md="6" class="form-group">
                      <label for="feFirstName">Nome</label>
                      <d-form-input :state="hasErrorFiled('name')" type="text" id="feFirstName" placeholder="Nome" v-model="model.name"/>
                      <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
                    </d-col>

                    <!-- E-mail -->
                    <d-col md="6" class="form-group">
                      <label for="feEmail">E-mail</label>
                      <d-form-input :state="hasErrorFiled('email')" type="email" id="feEmail" placeholder="E-mail" v-model="model.email" />
                      <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
                    </d-col>

                  </d-form-row>

                  <d-form-row v-if="!isCurrentUser">

                    <!-- User type -->
                    <d-col md="6" class="form-group">
                      <label for="feUserType">Tipo de usuário</label>
                      <d-select v-model="model.settings.type" @change="setSettings($event, 'user_type_id')">
                        <option :value="option" v-for="(option, index) in typesList" :key="index">{{ option.name }}</option>
                      </d-select>
                    </d-col>

                    <!-- Função -->
                    <d-col md="6" class="form-group" v-if="model.settings.user_type_id !== 1">
                      <label for="feRole">Função</label>
                      <d-select v-model="model.settings.role" @change="setSettings($event, 'role_id')">
                        <option :value="option" v-for="(option, index) in rolesList" :key="index">{{ option.name }}</option>
                      </d-select>
                    </d-col>

                  </d-form-row>

                  <d-form-row v-if="model.settings.type.slug === 'reseller' && isAdmin">

                    <!-- Reseller -->
                    <d-col md="12" class="form-group">
                      <label for="feEmail">Revendedor</label>
                      <autocomplete
                        ref="autocomplete"
                        placeholder="Revendedor"
                        :items="resellers"
                        item-show="name"
                        :on-input="onInput"
                        :on-select="saveReseller"
                      ></autocomplete>
                    </d-col>

                  </d-form-row>

                  <div class="list-group-item px-0 border-bottom-0">
                    <d-form-row>

                      <!-- Old Password -->
                      <d-col md="6" class="form-group" v-if="isCurrentUser">
                        <label for="feOldPassword">Senha antiga</label>
                        <d-form-input type="password" id="feOldPassword" placeholder="**********" v-model="model.old_password" />
                      </d-col>
                      <!-- Old Password -->
                      <d-col md="6" class="form-group" v-if="!isCurrentUser && model.id == null">
                        <!-- Generate Password -->
                        <label for="fePassword">Definir senha por e-mail</label>
                        <d-checkbox toggle :checked="sendPassword" @change="sendPassword = !sendPassword" class="custom-toggle-sm">Sim</d-checkbox>
                      </d-col>

                    </d-form-row>

                    <d-form-row>

                      <template v-if="!sendPassword || model.id || isCurrentUser">
                        <!-- Password -->
                        <d-col md="6" class="form-group">
                          <label for="fePassword">Senha</label>
                          <d-form-input :state="hasErrorFiled('password')" type="password" id="fePassword" placeholder="**********" v-model="model.password" />
                          <d-form-invalid-feedback>As senhas não são iguais</d-form-invalid-feedback>
                        </d-col>

                        <!-- Password -->
                        <d-col md="6" class="form-group">
                          <label for="fePasswordConfirmation">Confirmar senha</label>
                          <d-form-input :state="hasErrorFiled('password_confirmation')" type="password" id="fePasswordConfirmation" placeholder="**********" v-model="model.password_confirmation" />
                        </d-col>
                      </template>

                    </d-form-row>
                  </div>

                  <d-button type="submit" class="btn-accent">Salvar</d-button>

                </d-form>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
  </d-row>

</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import UploadImage from '_shared/UploadImage.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import UserService from '_services/rest/modules/user';
import ResellerService from '_services/rest/modules/reseller';
import { MODEL, _LOAD_MODEL_ } from './UserModel';
import { OPTION } from '../../settings/components/SettingsModel';


export default {
  name: 'user-account-details',
  mixins: [mixin, formatErrors],
  components: {
    UploadImage,
    Autocomplete,
  },
  props: {
    title: {
      type: String,
      default: 'Perfil',
    },
    isCurrentUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
    typesList() {
      const { userTypes } = this.$store.state.settings;
      if (userTypes && userTypes.length > 0) {
        return userTypes;
      }
      return [{ ...OPTION }];
    },
    roleName() {
      if (this.model.settings.user_type_id === 1) {
        return 'Administrador';
      }
      if (!this.model.settings.role.name) {
        return 'Nenhum';
      }
      return this.model.settings.role.name;
    },
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      sendPassword: true,
      resellers: [],
      errors: {
        name: { required: false },
        email: { required: false },
        password: { equals: false, field: 'password_confirmation' },
        password_confirmation: { equals: false, field: 'password' },
      },
    };
  },
  methods: {
    ...mapActions([
      'checkAdmin',
      'getRoles',
      'activeAlert',
      'setUserEdit',
      'getUserTypes',
      'saveUser',
    ]),
    getRoleId() {
      if (this.model.settings.role.id) {
        [this.model.settings.role] = this.rolesList;
      }

      return this.model.settings.role.id;
    },
    getOptions() {
      if (!this.$store.state.settings.roles) {
        this.getRoles();
      }
      if (!this.$store.state.settings.userTypes) {
        this.getUserTypes();
      }
    },
    setSettings(event, field = 'role_id') {
      setTimeout(() => {
        this.model.settings.role_id = null;
        if (field === 'user_type_id' && event.id !== 1) {
          this.model.settings.role_id = this.getRoleId();
        }
        this.model.settings[field] = event.id;
        if (this.model.settings.type.slug !== 'reseller') {
          this.model.settings.reseller_id = null;
          this.model.settings.reseller.id = null;
        }
        this.setUserEdit(this.model);
      }, 20);
    },
    saveReseller(reseller) {
      this.model.settings.reseller_id = reseller.id;
    },
    onInput(search) {
      const params = {
        search,
        skip: 0,
        take: 10,
        page: 1,
      };
      ResellerService.getList(params)
        .then(response => {
          this.resellers = response.list;
        });
    },
    save() {
      if (this.checkForm()) {
        if (this.isCurrentUser) {
          return this.saveUser(this.model)
            .then(response => {
              this.activeAlert({ message: response.message, theme: 'success' });
            }).catch(this.showError);
        }
        return UserService.save(this.model)
          .then(response => {
            this.activeAlert({ message: response.message, theme: 'success' });
            this.$router.push(`/admin/usuarios/${response.data.id}`);
          }).catch(this.showError);
      }
      return false;
    },
    setReseller(reseller) {
      if (this.$refs.autocomplete && reseller) {
        this.$refs.autocomplete.$refs.input.value = reseller.name;
      }
    },
  },
  mounted() {
    if (!this.isCurrentUser) {
      this.getOptions();
    }
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, user => {
      this.model = cloneDeep(user);
      setTimeout(() => {
        this.setReseller(user.settings.reseller);
      }, 10);
    });
  },
};
</script>
